import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BranchFunctionGroupsLogicService } from './logic/branch-function-groups/branch-function-groups-logic.service';
import { BranchFunctionGroupsService } from './logic/branch-function-groups.service';
import { BranchFunctionGroupsDaoService } from './dao/branch-function-groups-dao.service';
import { BranchFunctionGroupsDbDaoService } from './dao/branch-function-groups-dao/branch-function-groups-db-dao.service';
import { BranchFunctionGroupsDbTableDefinition } from './dao/branch-function-groups-dao/branch-function-groups-db-table-definition';
import { LocalBranchFunctionGroupsDbTableDefinition } from './dao/branch-function-groups-dao/local-branch-function-groups-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: BranchFunctionGroupsService, useClass: BranchFunctionGroupsLogicService },
    { provide: BranchFunctionGroupsDaoService, useClass: BranchFunctionGroupsDbDaoService },
    { provide: BranchFunctionGroupsDbTableDefinition },
    { provide: LocalBranchFunctionGroupsDbTableDefinition },
  ]
})
export class BranchFunctionGroupsModule {}
